/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileUnzipEndpointRequest
 */
export interface FileUnzipEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof FileUnzipEndpointRequest
     */
    input: string;
    /**
     * 
     * @type {boolean}
     * @memberof FileUnzipEndpointRequest
     */
    remove?: boolean;
}

export function FileUnzipEndpointRequestFromJSON(json: any): FileUnzipEndpointRequest {
    return FileUnzipEndpointRequestFromJSONTyped(json, false);
}

export function FileUnzipEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileUnzipEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'input': json['input'],
        'remove': !exists(json, 'remove') ? undefined : json['remove'],
    };
}

export function FileUnzipEndpointRequestToJSON(value?: FileUnzipEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'input': value.input,
        'remove': value.remove,
    };
}


